/* global globalThis */
import url from './apiURL';
import { authenticatedFetch } from "../../utils/authenticatedFetch";
import { getValidToken } from "../../utils/getValidToken";

// Helper to detect abort errors
const isAbortError = (error) =>
  error?.name === "AbortError" ||
  error?.message?.toLowerCase?.().includes("aborted");

export const fetchLossRecoveryFilters = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchLossRecoveryFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Loss Recovery Filters data:', error);
        throw error;
    }
};
export const fetchOrderToAllocationFilters = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Order to allocation Filters data:', error);
        throw error;
    }
};

export const fetchAllocationToDeliveryFilters = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching allocation to delivery Filters data:', error);
        throw error;
    }
};

export const fetchLossRecoveryOrderExpiry = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchLossRecoveryOrderExpiry, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Loss Recovery Order Expiry data:', error);
        throw error;
    }
};
export const fetchLossRecoveryKPIs = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchLossRecoveryKPIs, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Loss Recovery KPIs data:', error);
        throw error;
    }
};
export const fetchBGLevelSummary = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchBGLevelSummary, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching BG Level Summary data:', error);
        throw error;
    }
};
export const fetchChannelLevelSummary = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchChannelLevelSummary, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};
export const fetchLossRecoveryOverView = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchLossRecoveryOverView, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Loss Recovery Overview data:', error);
        throw error;
    }
};

export const exportLossRecoveryOverview = async (payload) => {
    const token = await getValidToken();
    try {
        const response = await fetch(url.exportLossRecoveryOverview, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute("download", `Loss_Recovery_Overview_${payload.uom}_${currentDate}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching Loss Recovery Overview Export data:', error);
        throw error;
    }
};
export const fetchOrderToAllocationOverviewTable = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Order to allocation Overview table data:', error);
        throw error;
    }
};

export const fetchLossReasons = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationLossReasons, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchLossvalidity = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationLossValidity, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchLossCategory = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationLossCategory, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchLossHeatMap = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchOrderToAllocationLossHeatMap, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchAllocationLossReasons = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchAllocationToDeliveryLossReasons, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchAllocationLossvalidity = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchAllocationToDeliveryLossValidity, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};

export const fetchAllocationLossCategory = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchAllocationToDeliveryLossCategory, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Channel Level Summary data:', error);
        throw error;
    }
};
export const fetchAllocationToDeliveryOverviewTable = async (payload, signal) => {
    try {
        return await authenticatedFetch(url.fetchAllocationToDeliveryOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
            signal,
        });
    } catch (error) {
        if (isAbortError(error)) throw error;
        console.error('Error fetching Allocation To Delivery Overview Table data:', error);
        throw error;
    }
};
